import { ISubtitleStyle } from './Subtitle';

export interface IUserPreferences {
  autoplayEnabled: boolean;
  volumePercent: number;
  markerPreviewEnabled: boolean;
  playbackRate: number;
  subtitle: {
    enabled: boolean;
    language: string;
    style: ISubtitleStyle;
  };
}

export enum APIUserPreferencesResources {
  default = '',
  subtitleStyle = '/subtitle/style',
}
